const setConversion = (conversion) => {
  return { type: 'SET_CONVERSION', payload: conversion };
};

export {
  setConversion,
}